<script>

    import { fade } from 'svelte/transition';
    import { onMount } from 'svelte';
    import {isReturnUser} from "../utils/localStorage";
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    function handleClick() {
        dispatch('close');
    }

    export let data;
    export let message;

    let show = false;

    onMount(() => {
        if (isReturnUser()){
            if (!sessionStorage.getItem('tochatsess')) {
                sessionStorage.setItem('tochatsess', "true");
                show = true;
            }
            setTimeout(() => (show = false), 3000);
        }
    });

</script>

{#if show}
<div
        style="background:{data.color}"
        class="welcome-back"
        in:fade="{{ delay:2000 }}" out:fade="{{ delay:4000 }}">


    {#if message}
        {message}
    {:else }
        <p>👋 Hello, we're glad your're back!</p>
        <p>If you have any questions, we would be happy to help.</p>
    {/if}
</div>
{/if}
{#if data.outCloseButton}
<div on:click={handleClick}
    class="close-chatwith"
    style="background-color:{data.color}"
    in:fade="{{ delay:100 }}">
    <svg aria-hidden="true" focusable="false"  data-icon="times"  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path fill="#fff" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>
</div>
{/if}

<style>
    .close-chatwith{
        top: 10px;
        width: 22px;
        height: 22px;
        padding-top: 2px;
        padding-left: 2px;
        margin-bottom: 8px;
        float: right;
        cursor:pointer;
    }

    .close-chatwith svg{
        width: 20px;
        height: 20px;
        display:block;
    }
    .welcome-back {
        box-sizing: border-box;
        min-width: 200px;
        max-width: 260px;
        padding: 10px 12px;
        margin: 10px;
        border-radius: 6px;
        background-color: white;
        box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
        text-align: center;
        font-size: .9rem;
        color: black;
    }

</style>
